<template>
    <div class="agreement">
      <section class="main-wrap">
        <h3 class="title">用户协议</h3>
        <div class="v-main">
          <ul>
            <li v-for="(li, index) in agreement" :key="'ag' + index">{{li.title}}</li>
          </ul>

          <div class="action-wrap">
            <button class="normal-btn btn d_button" @click="agree(false)">不同意</button>
            <button class="normal-btn btn a_button" @click="agree(true)">同意</button>
          </div>
        </div>
      </section>
    </div>
</template>

<script>
  import ActionBar from '../../components/action-bar';
  export default {
    name: "agreement",
    components: {
      ActionBar
    },
    data () {
      return {
        agreement: [
          {
            title: '01. 为避免出现争议，请您务必在下注之后查看「下注状况」。',
            type: 1
          },
          {
            title: '02. 任何投诉必须在开奖之前，本系统不接受任何开奖之后的投诉。',
            type: 1
          },
          {
            title: '03. 公布赔率时出现的任何打字错误或非故意人为失误，所有（相关）注单一律不算。',
            type: 1
          },
          {
            title: '04. 公布之所有赔率为浮动赔率，下注时请确认当前赔率及金额，下注确认后一律不能修改。',
            type: 1
          },
          {
            title: '05. 开奖后接受的投注，一律视为投机漏洞，[本局注单一律不返还本金及盈利]，敬请会员遵守游戏规则。',
            type: 1
          },
          {
            title: '06. 若本后台发现客户以不正当的手法投注或投注注单不正常，后台将有权「取消」相应之注单，客户不得有任何异议。',
            type: 1
          },
          {
            title: '07. 如因软件或线路问题导致交易内容或其他与账号设定不符合的情形，请在开奖前立即与本后台联络反映问题，否则本后台将以资料库中的数据为准。',
            type: 1
          },
          {
            title: '08. 倘若发生遭黑客入侵破坏行为或不可抗拒之灾害致网站故障或资料损坏、数据丢失等情况，后台将以资料库数据为依据。',
            type: 1
          },
          {
            title: '09. 各级管理人员及客户必须对本系统各项功能进行了解及熟悉，任何违反正常使用的操作，后台概不负责。',
            type: 1
          },
          {
            title: '10. 请认真了解各款彩票游戏规则。',
            type: 1
          },
          {
            title: '11. 如果会员信用额度超额或者为负数引起的争议，一律以公司处理为准。',
            type: 1
          },
          {
            title: '12. 客户有责任确保自己的账户及密码保密，如果因客户的账户、密码简单，或因泄露导致被盗用，造成的损失由客户本人承担；同时应立即通知本公司，并更改其个人详细资料。',
            type: 1
          },
          {
            title: '13. 若官方福彩中心开奖错误导致本系统采集数据同时出错情况下当期错误的所有注单以福彩中心官方网站更改后的数据为标准重新结算！在此特别声明，客户不得有任何异议。以上协议解释权归本系统所有。',
            type: 1
          }
        ]
      }
    },
    mounted () {
    },
    methods: {
      agree(status) {
        if (status) {
          this.$router.replace('/home');
        } else {
          this.$router.replace('/login');
        }
      }
    },
  }
</script>

<style scoped lang="less">
  .agreement{
    padding: 20px 40px;
    font-size: 30px;
    background: #502d0a;
    box-sizing: border-box;
    .main-wrap {
      border-radius: 10px;
      h3 {
        color: #fff;
        height: 60px;
        text-align: center;
        background: linear-gradient(#ce5f73, #b03b50);
        font-weight: bold;
        line-height: 60px;
      }
      .v-main{
        padding: 20px 40px;
        font-size: 26px;
        box-sizing: border-box;
        background: #fff url("./images/bg.png")repeat-x left top;
        ul{
          padding: 20px 0;
          box-sizing: border-box;
          border-bottom: 1px solid #e0e0e0;
          li{
            margin-top: 35px;
            line-height: 36px;
          }
        }
        .action-wrap{
          margin: 30px 0;
          display: flex;
          text-align: center;
          justify-content: space-between;
          .normal-btn{
            color: #fff;
            height: 50px;
            border: 1px solid #e0e0e0;
            padding: 0 20px;
            font-size: 24px;
            box-sizing: border-box;
            border-radius: 10px;
          }
          .a_button{
            background: linear-gradient(#c84b5d, #b72a3c);
          }
          .d_button{
            background: linear-gradient(#d86f80, #cc425a);
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/agreement/index.vue